import { Button } from "@material-ui/core";
import React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { addSection } from "./redux/demoreducer";
import { addTodos } from "./redux/reducer";

function SectionCard(props) {
  //   console.log("props", props);

  const [todo, setTodo] = useState("");
  const [section, setSection] = useState({
    currentSection: {
      sectionTitle: "",
      sectionDescription: "",
      contentType: "video/document/assignment/quiz",
      contentTitle: "",
      credits: 10,
      contentDescription: "",
      resourceUploadLink:
        "videolink/documentlink/assignment document link/ quiz excel link",
      quizPassingGrade: 80,
      quizTime: 1000, //seconds
      sectionSubmitType: "pdf/word/image/audio/video/excel/any",
      videoTime: 4500, // seconds : calculate the time in frontend and send the seconds to server,
    },
  });
  const handleChange = (e) => {
    setSection({
      currentSection: {
        ...section.currentSection,
        [e.target.name]: e.target.value,
      },
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Course Object : ", section);
  };
  const add = (e) => {
    e.preventDefault();
    if (section.currentSection.sectionTitle === "") {
      alert("Input is Empty");
    } else {
      props.addSection({
        id: Math.floor(Math.random() * 1000),
        title: section.currentSection.sectionTitle,
        description: section.currentSection.sectionDescription,
        completed: false,
      });
    }
    alert(`Section added `);
  };
  const handleChange_ = (e) => {
    setTodo(e.target.value);
  };
  return (
    <div>
      <form>
        <input
          type="text"
          placeholder="Section Title"
          name="sectionTitle"
          onChange={handleChange}
          value={section.currentSection.sectionTitle}
        />
        <input
          type="text"
          placeholder="Section Description"
          name="sectionDescription"
          onChange={handleChange}
          value={section.currentSection.sectionDescription}
        />
        <button className="add-btn" onClick={(e) => add(e)}>
          Add
        </button>
        {/*   <Button type="submit" onClick={() => add()}>
          Submit
        </Button> */}
      </form>
      {/* <input
        type="text"
        onChange={(e) => handleChange_(e)}
        className="todo-input"
        value={todo}
      /> */}

      {/*  <button className="add-btn" onClick={() => add()}>
        Add
      </button> */}
      <br />

      {/*  <div>
        {props.section.length > 0 &&
          props.section.map((item) => {
            return (
              <div key={item.id} style={{ display: "flex" }}>
                <p style={{ marginRight: "5%" }}>{item.title}</p>
                <p>{item.description}</p>
              </div>
            );
          })}
      </div> */}
      <p>{props.type}</p>
      <p>{props.index_}</p>
    </div>
  );
}
/* const mapStateToProps = (state) => {
  return {
    todos: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addTodo: (obj) => dispatch(addTodos(obj)),
  };
}; */
const mapStateToProps = (state) => {
  return {
    section: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSection: (obj) => dispatch(addSection(obj)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SectionCard);
